module.exports = __webpack_public_path__ + "22ee204ba1fd3e1cb7711b534894806a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003AKE.png
// module id = 1504
// module chunks = 0